import { render, staticRenderFns } from "./CustomerProductDetailsList.vue?vue&type=template&id=0803c2d8&scoped=true&"
import script from "./CustomerProductDetailsList.vue?vue&type=script&lang=js&"
export * from "./CustomerProductDetailsList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerProductDetailsList.vue?vue&type=style&index=0&id=0803c2d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0803c2d8",
  null
  
)

export default component.exports